import { z } from "zod";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const MAX_DELIVERY_NOTE_SIZE = 5 * 1024 * 1024;

export const DELIVERY_NOTE_TYPES = ["image/jpeg", "image/png", "application/pdf"];

export interface CompleteDeliveryValues {
  delivered_quantity: string;
  paid: "yes" | "no";
  payment_amount: string;
  delivery_payment_method: string;
  includes_delivery_cost: boolean;
}

const isPositive = (value: string) => {
  const amount = Number(value);
  return value.trim() !== "" && Number.isFinite(amount) && amount > 0;
};

export const createCompleteDeliverySchema = (t: TranslateFn) =>
  z
    .object({
      delivered_quantity: z.string(),
      paid: z.enum(["yes", "no"]),
      payment_amount: z.string(),
      delivery_payment_method: z.string(),
      includes_delivery_cost: z.boolean(),
    })
    .superRefine((values, ctx) => {
      if (!isPositive(values.delivered_quantity)) {
        ctx.addIssue({
          code: "custom",
          path: ["delivered_quantity"],
          message: t("completeDeliveryModal.positiveNumber"),
        });
      }
      if (values.paid !== "yes") {
        return;
      }
      if (!isPositive(values.payment_amount)) {
        ctx.addIssue({
          code: "custom",
          path: ["payment_amount"],
          message: t("completeDeliveryModal.positiveNumber"),
        });
      }
      if (!values.delivery_payment_method) {
        ctx.addIssue({
          code: "custom",
          path: ["delivery_payment_method"],
          message: t("traderDetails.form.mandatoryFieldBlankError"),
        });
      }
    });

export const deliveryNoteIssue = (file: File | null, t: TranslateFn): string | undefined => {
  if (!file) {
    return undefined;
  }
  if (!DELIVERY_NOTE_TYPES.includes(file.type)) {
    return t("completeDeliveryModal.noteType");
  }
  if (file.size > MAX_DELIVERY_NOTE_SIZE) {
    return t("completeDeliveryModal.noteSize");
  }
  return undefined;
};
